module.exports = __webpack_public_path__ + "static/media/20170430-DSC02444-1_Small.93a43722.jpg";